<template>
  <div class="pa-4">
    <v-row justify="space-between">
      <v-col class="text-h4" cols="12" sm="auto">{{ $vuetify.lang.t("$vuetify.user.title") }}</v-col>
      <v-col cols="12" sm="auto">
        <v-btn :to="{ name: 'Dashboard' }" color="secondary" text large exact>
          <v-icon>mdi-arrow-left</v-icon>
          {{ $vuetify.lang.t("$vuetify.buttons.backToDashboard") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="9">
        <v-card>
          <v-card-title class="primary--text justify-center">
            {{ $vuetify.lang.t("$vuetify.user.myAccount") }}
          </v-card-title>
          <v-card-text>
            <FormUser ref="formUser" @success="formSuccess" @error="$emit('control-overlay', false)"></FormUser>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" depressed right large @click="submitForm">
              <v-icon left dark>mdi-content-save</v-icon>
              {{ $vuetify.lang.t("$vuetify.buttons.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import userApi from "@/api/user";
import tokenService from "@/services/token";
import FormUser from "@/components/forms/User";
export default {
  name: "MyAccount",
  components: { FormUser },
  mounted() {
    // Hide Overlay
    this.$emit("control-overlay", true);
    // Verify logged User
    if (!tokenService.getToken()) this.$router.push({ name: "Dashboard" });
    // Get Logged User Data
    let userData = tokenService.getDecodedToken();
    // Check if user exists
    if (!userData.user && !userData.user.id) this.$router.push({ name: "Dashboard" });
    // Get User
    userApi
      .getById(userData.user.id)
      .then((response) => {
        // set User Obj
        this.$refs.formUser.setUserObj(response);
      })
      .catch((error) => {
        this.$notify({
          group: "application",
          type: "error",
          title: this.$vuetify.lang.t("$vuetify.api.user.errors.getById"),
          text: error.message,
        });
      })
      .finally(() => {
        // Hide Overlay
        this.$emit("control-overlay", false);
      });
  },
  methods: {
    // Submit Form function
    submitForm(e) {
      // Prevent default action
      e.preventDefault();
      // Show Overlay
      this.$emit("control-overlay", true);
      // validate form
      this.$refs.formUser.submitForm();
    },
    formSuccess() {
      // Redirect to Index
      this.$notify({
        group: "application",
        type: "success",
        title: this.$vuetify.lang.t("$vuetify.user.notifications.success.updateUser.title"),
        text: this.$vuetify.lang.t("$vuetify.user.notifications.success.updateUser.message"),
      });
      // Hide Overlay
      this.$emit("control-overlay", false);
    },
  },
};
</script>
